export default __webpack_public_path__ + "static/media/AiS_Logo (1).799c0520.svg";